"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var flApi = require("./flApi");
var Entities = (function () {
    function Entities() {
        this.AllEntities = [];
    }
    Entities.prototype.loadNewDico = function (dicos) {
        var myFi;
        var secondPassField = ["rollup", "linkedField"];
        this.AllEntities = [];
        for (var i = 0; i < dicos.length; i++) {
            try {
                switch (dicos[i].c2) {
                    case "E":
                        var tmpEnt = this.createEntityObjectFromJson(dicos[i]);
                        this.AllEntities.push(tmpEnt[0]);
                        break;
                    case "F":
                        myFi = dicos[i];
                        var myEnti = this.getByEcn(myFi.c1);
                        if (myEnti === null) {
                            throw new Error("Entity " + myFi.c1 + " not found: " + JSON.stringify(dicos[i]));
                        }
                        if (secondPassField.indexOf(myFi.c7) === -1) {
                            myEnti.addField(dicos[i]);
                        }
                }
            }
            catch (err) {
                console.error("Error during dico loading for: " + JSON.stringify(dicos[i]));
            }
        }
        for (var i = 0; i < dicos.length; i++) {
            try {
                switch (dicos[i].c2) {
                    case "E":
                        break;
                    case "F":
                        myFi = dicos[i];
                        var myEnti = this.getByEcn(myFi.c1);
                        if (myEnti === null) {
                            throw new Error("Entity " + myFi.c1 + " not found: " + JSON.stringify(dicos[i]));
                        }
                        if (secondPassField.indexOf(myFi.c7) !== -1) {
                            myEnti.addField(dicos[i]);
                        }
                }
            }
            catch (err) {
                console.error("Error during dico loading for: " + JSON.stringify(dicos[i]));
            }
        }
    };
    Entities.prototype.getByEcn = function (id) {
        try {
            for (var i = 0; i < this.AllEntities.length; i++) {
                if (this.AllEntities[i].id === id) {
                    return this.AllEntities[i];
                }
            }
            return null;
        }
        catch (err) {
            console.log("flClient: getByEcn, exception: " + err.stack);
            this.AllEntities = [];
            err = err.stack === undefined ? new Error(err) : err;
            throw err;
        }
    };
    Entities.prototype.getByFcn = function (id) {
        var e_1, _a, e_2, _b;
        try {
            try {
                for (var _c = __values(this.AllEntities), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var anEnt = _d.value;
                    try {
                        for (var _e = (e_2 = void 0, __values(anEnt.fields)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var aField = _f.value;
                            if (aField.id === id) {
                                return aField;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
        }
        catch (err) {
            console.log("flClient: getByFcn, exception: " + err.stack);
            this.AllEntities = [];
            err = err.stack === undefined ? new Error(err) : err;
            throw err;
        }
    };
    Entities.prototype.getBySingular = function (stringName) {
        var e_3, _a;
        try {
            var mySingName = stringName.toLowerCase();
            try {
                for (var _b = __values(this.AllEntities), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var anEnt = _c.value;
                    if (anEnt.singular.toLowerCase() === mySingName) {
                        return anEnt;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return null;
        }
        catch (err) {
            console.log("flClient: getBySingular, exception: " + err.stack);
            this.AllEntities = [];
            err = err.stack === undefined ? new Error(err) : err;
            throw err;
        }
    };
    Entities.prototype.entityCount = function () {
        return this.AllEntities.length;
    };
    Entities.prototype.createEntityObjectFromJson = function (docEntity) {
        var e_4, _a;
        try {
            var arrEnt = [];
            var jEntities = docEntity instanceof Array ? docEntity : [docEntity];
            try {
                for (var jEntities_1 = __values(jEntities), jEntities_1_1 = jEntities_1.next(); !jEntities_1_1.done; jEntities_1_1 = jEntities_1.next()) {
                    var aJEnt = jEntities_1_1.value;
                    var myEnt = new flApi.EntityClass(aJEnt);
                    arrEnt.push(myEnt);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (jEntities_1_1 && !jEntities_1_1.done && (_a = jEntities_1.return)) _a.call(jEntities_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return arrEnt;
        }
        catch (err) {
            console.error(err.stack || err);
            err = err.stack === undefined ? new Error(err) : err;
            throw err;
        }
    };
    Entities.prototype.add = function (docEntity, bLoadInDB) {
        if (bLoadInDB === void 0) { bLoadInDB = true; }
        return __awaiter(this, void 0, void 0, function () {
            var flapi, arrEnt, entityClasses, jEntities, jEntities_2, jEntities_2_1, aJEnt, myEnt, srvDocEntity, srvDocEntity_1, srvDocEntity_1_1, aEntDoc, tmpEntObj, err_1;
            var e_5, _a, e_6, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        if (!bLoadInDB) {
                            return [2, this.createEntityObjectFromJson(docEntity)];
                        }
                        flapi = flApi.Api.getInstance();
                        arrEnt = [];
                        entityClasses = [];
                        jEntities = docEntity instanceof Array ? docEntity : [docEntity];
                        try {
                            for (jEntities_2 = __values(jEntities), jEntities_2_1 = jEntities_2.next(); !jEntities_2_1.done; jEntities_2_1 = jEntities_2.next()) {
                                aJEnt = jEntities_2_1.value;
                                myEnt = new flApi.EntityClass(aJEnt);
                                entityClasses.push(myEnt.decode());
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (jEntities_2_1 && !jEntities_2_1.done && (_a = jEntities_2.return)) _a.call(jEntities_2);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        return [4, flapi.restApi.insertDocuments(0, entityClasses, "", 1)];
                    case 1:
                        srvDocEntity = _c.sent();
                        try {
                            for (srvDocEntity_1 = __values(srvDocEntity), srvDocEntity_1_1 = srvDocEntity_1.next(); !srvDocEntity_1_1.done; srvDocEntity_1_1 = srvDocEntity_1.next()) {
                                aEntDoc = srvDocEntity_1_1.value;
                                tmpEntObj = new flApi.EntityClass(aEntDoc);
                                if (flapi.entities.getByEcn(tmpEntObj.id) === null) {
                                    this.AllEntities.push(tmpEntObj);
                                }
                                arrEnt.push(tmpEntObj);
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (srvDocEntity_1_1 && !srvDocEntity_1_1.done && (_b = srvDocEntity_1.return)) _b.call(srvDocEntity_1);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        return [2, arrEnt];
                    case 2:
                        err_1 = _c.sent();
                        console.error(err_1.stack || err_1);
                        err_1 = err_1.stack === undefined ? new Error(err_1) : err_1;
                        throw err_1;
                    case 3: return [2];
                }
            });
        });
    };
    Entities.prototype.postProcess = function () {
        var e_7, _a;
        try {
            for (var _b = __values(this.AllEntities), _c = _b.next(); !_c.done; _c = _b.next()) {
                var myEnt = _c.value;
                myEnt.postProcess();
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    Entities.prototype.addItem = function (newEnt) {
        this.AllEntities.push(newEnt);
    };
    Entities.prototype.removeEntityOrField = function (eCN, fcn) {
        var e_8, _a, e_9, _b;
        if (fcn === void 0) { fcn = -1; }
        try {
            if (fcn === -1) {
                var tmpArr = [];
                try {
                    for (var _c = __values(this.AllEntities), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var anEnt = _d.value;
                        if (anEnt.id !== eCN) {
                            tmpArr.push(anEnt);
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                if (tmpArr.length !== this.AllEntities.length) {
                    this.AllEntities = tmpArr;
                }
            }
            else {
                try {
                    for (var _e = __values(this.AllEntities), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var anEnt = _f.value;
                        if (anEnt.getField(fcn) !== null) {
                            anEnt.removeField(fcn);
                            return;
                        }
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (err) {
            console.error("RemoveEntityOrField, exception: " + err.stack);
            err = err.stack === undefined ? new Error(err) : err;
            throw err;
        }
    };
    Entities.prototype.buildFullEntity = function (singular, fields) {
        return __awaiter(this, void 0, void 0, function () {
            var myEnt_1, errTry_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.add({ singular: singular })];
                    case 1:
                        myEnt_1 = (_a.sent())[0];
                        fields.forEach(function (aField) {
                            aField.eCN = myEnt_1.id;
                            switch (aField.systemType) {
                                case "pointer":
                                    aField.pointer[0].ptEcn = myEnt_1.id;
                                    break;
                                case undefined:
                                    aField.systemType = "string";
                                    break;
                            }
                        });
                        return [4, myEnt_1.createField(fields)];
                    case 2:
                        _a.sent();
                        return [2, myEnt_1];
                    case 3:
                        errTry_1 = _a.sent();
                        throw errTry_1;
                    case 4: return [2];
                }
            });
        });
    };
    Entities.prototype.buildDefaultDDEntry = function (singular, modelObj) {
        var _this = this;
        return new Promise(function (c, r) { return __awaiter(_this, void 0, void 0, function () {
            var myEnt, jDocStrFis, key, errTry_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.add({ singular: singular })];
                    case 1:
                        myEnt = (_a.sent())[0];
                        jDocStrFis = [];
                        for (key in modelObj) {
                            if (modelObj.hasOwnProperty(key)) {
                                jDocStrFis.push({ singular: key, UI: { label: key } });
                            }
                        }
                        return [4, myEnt.createStringField(jDocStrFis)];
                    case 2:
                        _a.sent();
                        myEnt = this.getByEcn(myEnt.id);
                        return [2, c(myEnt)];
                    case 3:
                        errTry_2 = _a.sent();
                        return [2, r(errTry_2)];
                    case 4: return [2];
                }
            });
        }); });
    };
    Entities.prototype.getAllEntities = function () {
        return this.AllEntities;
    };
    Entities.prototype.dump = function (myIdent, bDumpName, bDisplay) {
        if (myIdent === void 0) { myIdent = 0; }
        if (bDumpName === void 0) { bDumpName = true; }
        if (bDisplay === void 0) { bDisplay = false; }
        var dumpStr = "----- Full Dictionary dump -----\n";
        this.AllEntities.forEach(function (anEnt) {
            dumpStr += anEnt.dump(myIdent + 2, bDumpName, bDisplay);
        });
    };
    return Entities;
}());
exports.default = Entities;
